import axios from 'axios'
import config from '../config'
import FileSaver from 'file-saver'
import { addAuthToken } from '../helper'
import processError from '../../helpers/processError'
import qs from 'qs'

const OrdersManager = {
  getDocumentByURL: async ({ url, name }) => {
    const response = await fetch(url, config)

    if (!response.ok) {
      return await response.json()
    }

    response.blob().then((data) => {
      FileSaver.saveAs(data, name)
    })
  },

  getOrderById: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/web-app/${orderId}`
    const response = await fetch(url, addAuthToken({}))
    const orderData = await response.json()
    if (!response.ok) {
      throw new Error(processError(orderData))
    }

    return orderData
  },

  getSubmissionsByOrderId: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/submissions/${orderId}`
    const submissionsResponse = await fetch(url, addAuthToken({}))
    const submissionsData = await submissionsResponse.json()
    if (!submissionsResponse.ok) {
      throw new Error(processError(submissionsData))
    }

    return submissionsData.submissions
  },

  getReviewResults: async (orderId, submissionId, submissionFileCreated) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/submissions/${submissionId}/review-results`
    const response = await axios.request(addAuthToken({
      url,
      params: {
        submission_file_created: submissionFileCreated,
      },
    }))
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },

  getAcceptRequirements: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/accept-requirements`
    const response = await axios.request(addAuthToken({ url }))
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },

  getEligibleAppraisers: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/eligible-appraisers`
    const response = await axios.request(addAuthToken({ url }))
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },

  getAssistedAssignmentInfo: async (orderId, params) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/assisted-assignment`
    const response = await axios.request(
      addAuthToken({
        url,
        params,
        paramsSerializer: (parameters) => qs.stringify(parameters, { indices: false }),
      }),
    )
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },

  getEligibleAppraiserProximity: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/eligible-appraisers-proximity`
    const response = await axios.request(addAuthToken({ url }))
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },

  getInspectionAvailability: async (orderId) => {
    const url = `${SERVER_BASE_URL}/api/orders/${orderId}/inspection-availability`
    const response = await axios.request(addAuthToken({ url }))
    if (response.status !== 200) {
      throw new Error(processError(response?.data))
    }

    return response.data
  },
}

export default OrdersManager
